export const FETCH_ALL_APPLICANTS = 'FETCH_ALL_APPLICANTS'
export const FETCH_APPLICANT = 'FETCH_APPLICANT'
